export default {
  "ThirdPartySummary.Title": "第三者提供の管理",
  "ThirdPartySummary.Text1":
    "ご自身のデータ提供に同意いただくと、さまざまな特典をお受け取りいただけます",
  "ThirdPartySummary.Text2":
    "サービスのご利用に必要なデータ提供や法令で認められている範囲でお客さまの同意を得る必要がない場合のデータ提供は、表示されておりません",
}
